import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import NavMenu from './NavMenu';
import logo from '../../img/logo4.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/sobre" className="logo-link" onClick={closeMenu}>
          <img  src={logo} className="logo"  alt="Infosfera" 
            title="Logo da Infosfera" 
          />
        </Link>
        
        {/* Menu Desktop SEMPRE visível */}
        <nav className="nav-desktop">
          <ul>
            <li><Link to="/">Home</Link></li>         
            <li><Link to="/sobre">Sobre</Link></li>
            <li><Link to="/contato">Contacto</Link></li>
          </ul>
        </nav>
        
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
          aria-label="Menu de navegação"
          aria-expanded={isMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        
        <NavMenu isOpen={isMenuOpen} onClose={closeMenu} />
        
        {isMenuOpen && (
          <div className="menu-overlay" onClick={closeMenu}></div>
        )}
      </div>
    </header>
  );
};

export default Header;